import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { SignedDocument } from 'src/app/classes/models';
import { AuthService } from 'src/app/services/auth.service';
import { GridService } from 'src/app/services/grid.service';
import { SignedDocumentService } from 'src/app/services/signed-document.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-signed-documents-grid',
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    './signed-documents-grid.component.less',
    '../base-grid/base-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SignedDocumentsGridComponent extends BaseGridComponent {
  constructor(
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService,
    private SignedDocumentService: SignedDocumentService
  ) {
    super(GridService, UtilityService, AuthService);

    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'SignedDocument';
    this.rowModelType = 'serverSide';
    this.suppressFieldDotNotation = false;

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.SignedDocumentService.getSignedDocuments(queryObject),
          this.SignedDocumentService.getSignedDocumentCount(countQueryObject)
        ]).subscribe({
          next: ([SignedDocuments, SignedDocumentCount]: [
            SignedDocument[],
            number
          ]) => {
            const successObject: {
              rowData: SignedDocument[];
              rowCount: number;
            } = {
              rowData: SignedDocuments,
              rowCount: SignedDocumentCount
            };

            params.success(successObject);
          },
          error: (error) => {
            console.log(error);
            params.fail();
          }
        });
      }
    };
  }
}
